import { NgModule } from "@angular/core";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule, MatDateRangePicker } from "@angular/material/datepicker";

const COMPONENTS = [MatNativeDateModule, MatDatepickerModule, MatDateRangePicker];
@NgModule({
  imports: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class DateInputModule {}
